//
//
//
//
//
import each from 'lodash/fp/each';
export default {
  methods: {
    reset: function reset() {
      var _this = this;

      // FIXME: elements/type uses api/resultType so we have to reset api first.
      each(function (m) {
        return _this.$store.dispatch("".concat(m, "/reset"));
      })(['filters', 'api', 'elements', 'pagination', 'history']);
    }
  }
};